Ext.ns('mx.comp.meta');

mx.comp.meta.Builder = function(type) {
    this.type = type;
};

mx.comp.meta.Builder.prototype = {
    getElement: function(name, config) {
        config['attributeName'] = name;
        if (!config.fieldLabel) {
            config['fieldLabel'] = name;
        }
        return this.build[this.type].call(this, name, config);
    },
    build: {
        STRING: function(name, config) {
            return new mx.comp.meta.TextField(config);
        },
        BOOLEAN: function(name, config) {
            return new mx.comp.meta.CheckBox(config);
        },
        INTEGER: function(name, config) {
            if (!config.strategy) {
                config.strategy = {
                    xtype: 'number',
                    minValue: 0,
                    decimalPrecision: 0,
                    incrementValue: 1,
                };
            }
            return new mx.comp.meta.Spinner(config);
        },
    },
};
